const validateRowKey = (items, rowKeyExtractor)=>{
    if (items.length > 0 && typeof items[0] !== 'string' && (!items[0]?.id || typeof items[0].id !== 'string') && !rowKeyExtractor) {
        throw new Error('rowKeyExtractor is required if items are not strings or do not have an id property');
    }
};
const getTableCellValue = (children)=>{
    let value = children;
    if (typeof children === 'string' || typeof children === 'number' || typeof children === 'boolean') {
        value = String(children);
    }
    if (!children) {
        value = '–';
    }
    return value;
};

export { getTableCellValue, validateRowKey };
//# sourceMappingURL=tableUtils.mjs.map
